// extracted by mini-css-extract-plugin
module.exports = {"Container":"Visual_Container__3IAOh","Header":"Visual_Header__3o0TX","Graphs":"Visual_Graphs__1V6xs"};